






































import { defineComponent, PropType } from "@vue/composition-api";

export default defineComponent({
  name: "Autocomplete",
  data() {
    return {
      search: null as string | null,
      isLoadDefaultItems: false,
      isFocus: false,
      isSelectedAfterFocus: false,
      menuProps: {
        zIndex: 1000,
      },
    };
  },
  model: {
    prop: "selected",
    event: "change",
  },
  props: {
    selected: {
      type: Object,
      default() {
        return {};
      },
    },
    showSelectedKey: {
      type: String,
      default() {
        return "code";
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
    value: {
      type: String,
      default() {
        return "titleValue"; // key of shown list of results
      },
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    beforeEmitSearchKeys: {
      type: Array as PropType<string[]>,
      default() {
        return ["code", "name"];
      },
    },
    attach: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    isEmptyValue() {
      return !this.selected || !Object.keys(this.selected).length;
    },
  },
  methods: {
    changeHandler(event: any) {
      this.isSelectedAfterFocus = true;
      this.$emit("change", event);
    },
    loadDefaultItems() {
      if (!this.search && this.isEmptyValue) {
        this.emitSearchText("");
      }
    },
    fieldOnBlur() {
      this.isFocus = false;

      if (this.search && !this.isSelectedAfterFocus) {
        this.$emit("saveSearchAsSelected", this.search);
      }
      if (this.search && this.isEmptyValue) {
        this.isLoadDefaultItems = true;
        this.search = "";
      }
    },
    fieldOnFocus() {
      this.isFocus = true;
      this.isSelectedAfterFocus = false;
      this.loadDefaultItems();
    },
    emitSearchText(val: string | null) {
      if (this.isLoadDefaultItems) {
        this.isLoadDefaultItems = false;
        return;
      }
      this.beforeEmitSearchKeys.some((key) => {
        return this.selected?.[key] !== val;
      }) && this.$emit("search-text", val || "");
    },
  },
  watch: {
    search(val) {
      this.emitSearchText(val);
    },
    isEmptyValue(value: boolean) {
      if (value && this.search) {
        this.isLoadDefaultItems = true;
        this.search = "";
      }
    },
  },
});
